import PhoneInput from 'react-phone-input-2';

export type PhonenumberInputProps = {
  label: string;
  value: string;
  setValue: (value: string | { (value: string): string }) => unknown;
  placeholder?: string;
  disabled?: boolean;
};

const PhonenumberInput = (props: PhonenumberInputProps) => {
  const { value, setValue, label, placeholder, disabled } = props;

  return (
    <label className={`flex w-full flex-col`}>
      <span className={`font-roboto text-b2 font-normal text-gray-100`}>
        {label}
      </span>
      <PhoneInput
        placeholder={placeholder}
        country={`us`}
        value={value}
        onChange={setValue}
        containerClass={`text-gray-600 relative mt-[4px] mb-[8px] text-b2`}
        inputClass={`w-full rounded-[8px] bg-gray-25 py-[13px] px-[16px] font-roboto text-b2 font-normal text-gray-600 placeholder:text-gray-50 focus:outline-none focus:ring-1 focus:ring-green-100 appearance-none`}
        disabled={disabled}
      />
    </label>
  );
};

export default PhonenumberInput;
